import {formatDisplayDate} from 'utils/dates';

const STAY_DATE: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
};

function formatStayDate(date: Parameters<typeof formatDisplayDate>[0], language: string) {
  return formatDisplayDate(date, language, STAY_DATE)?.replace(',', '');
}

export {formatStayDate};
